import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ConsentTable from "./consent-table";
import DisclaimersTable from "./disclaimers-table";
import DefaultDisclaimerTable from "./default-disclaimer-table";
import DisclaimersLoader from "./disclaimers-loader";
import { mapActions, mapState, mapGetters } from "vuex";
import { DOWNLOAD_DOCUMENT_NO_CLIENT } from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import { DEFAULT_DISCLAIMER_ID } from "@Shared/js/constants";
import { LOAD_DISCLAIMERS, DELETE_DISCLAIMER, CREATE_DISCLAIMER, UPDATE_DEFAULT_DISCLAIMER_ENABLED, UPDATE_DISCLAIMER } from "../store/disclaimers-actions";
import { IS_DEFAULT_DISCLAIMER_ENABLED, GET_DISCLAIMERS_FILTERED, GET_DEFAULT_DISCLAIMER } from "../store/disclaimers-getters";
import AddDisclaimerModal from "./add-disclaimer-modal";
import DocumentPreviewModal from "@Shared/components/document-previewer/document-preview-modal.vue";
import { openFileDialog } from "@Shared/utils/utils";
import Err from "@Broker/@Routes/error";
import { handleAlignment } from "@Broker/js/custom/utils";
import { replace } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationDisclaimers",
  components: {
    ConsentTable,
    DisclaimersTable,
    AddDisclaimerModal,
    DisclaimersLoader,
    DocumentPreviewModal,
    DefaultDisclaimerTable
  },
  props: {
    isBrokerage: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: true,
      consent: true,
      currentEditingDisclaimer: null,
      url: "",
      currentDocumentId: "",
      currentFileName: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails"])), mapGetters("DisclaimersStore", [GET_DISCLAIMERS_FILTERED, IS_DEFAULT_DISCLAIMER_ENABLED, GET_DEFAULT_DISCLAIMER])), {}, {
    disclaimers() {
      var _context;
      return _filterInstanceProperty(_context = this.GET_DISCLAIMERS_FILTERED(false)).call(_context, ({
        id
      }) => id !== DEFAULT_DISCLAIMER_ID);
    }
  }),
  beforeMount() {
    $(".nav-item").removeClass("navbar-active");
    $("#disclaimers").addClass("navbar-active");
  },
  mounted() {
    this.$nextTick(async () => {
      await this.loadDisclaimers();
      handleAlignment("disclaimers");
      this.loading = false;
    });
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("DisclaimersStore", [LOAD_DISCLAIMERS, DELETE_DISCLAIMER, CREATE_DISCLAIMER, UPDATE_DEFAULT_DISCLAIMER_ENABLED, UPDATE_DISCLAIMER])), mapActions("DocumentsStore", [DOWNLOAD_DOCUMENT_NO_CLIENT])), {}, {
    async loadDisclaimers() {
      await this.LOAD_DISCLAIMERS({
        isBrokerage: this.isBrokerage
      });
    },
    async deleteDisclaimer({
      disclaimer,
      defaultDisclaimerEnabled
    }) {
      await this.DELETE_DISCLAIMER({
        isBrokerage: this.isBrokerage,
        id: disclaimer.id,
        defaultDisclaimerEnabled: defaultDisclaimerEnabled != null ? defaultDisclaimerEnabled : this.IS_DEFAULT_DISCLAIMER_ENABLED
      });
    },
    async createDisclaimer(newDisclaimer) {
      if (newDisclaimer.fileName) newDisclaimer.fileName = this.formatFileExtension(newDisclaimer.fileName);
      await this.CREATE_DISCLAIMER({
        isBrokerage: this.isBrokerage,
        newDisclaimer
      });
      this.$refs.addDisclaimerModal.hide();
      this.$refs.addDisclaimerModal.loading = false;
    },
    openAddModal(option) {
      this.consent = option;
      this.$refs.addDisclaimerModal.show();
    },
    async showDocumentPreviewer({
      fileName,
      documentId
    }) {
      this.url = await this.DOWNLOAD_DOCUMENT_NO_CLIENT({
        fileName,
        documentId
      });
      this.currentFileName = fileName;
      this.currentDocumentId = documentId;
      this.$refs.previewDocumentModal.show();
    },
    handleDownloadDocument() {
      try {
        openFileDialog(this.url, this.currentFileName);
      } catch (e) {
        const message = "cannotDownloadFile";
        Err.handle(e, {}, message);
      }
    },
    formatFileExtension(fileName) {
      const extension = fileName.split(".").pop();
      if (extension === "pdf") return fileName;
      return replace(fileName, extension, "pdf");
    },
    async updateDefaultDisclaimerEnabled(defaultDisclaimerEnabled) {
      await this.UPDATE_DEFAULT_DISCLAIMER_ENABLED({
        isBrokerage: this.isBrokerage,
        defaultDisclaimerEnabled
      });
    },
    openEditDisclaimer(disclaimer) {
      this.currentEditingDisclaimer = disclaimer;
      this.openAddModal(disclaimer.consent);
    },
    async updateDisclaimer(disclaimer) {
      await this.UPDATE_DISCLAIMER({
        isBrokerage: this.isBrokerage,
        disclaimer
      });
    },
    async handleEditDisclaimer(disclaimer) {
      try {
        await this.updateDisclaimer(disclaimer);
        this.$refs.addDisclaimerModal.hide();
      } catch (e) {
        this.$refs.addDisclaimerModal.loadingStatus = false;
        this.$refs.addDisclaimerModal.loading = false;
      }
    }
  })
});